<template>
	<div class="contentPage">
		<main-table
				v-if="updateBillingData"
				:flag="flag"
				:pageTitle='title'
				:isCreate="false"
				:headers="headers"
				:listItems="updateBillingData"
				:filtersList="updateBillingFilters"
				@updateClickButton="onClickButton"
				@updateEdit="onEdit"
				@updateSearch="onFilters"
				@updateRefreshFilters="onFilters"
				:updateRefreshFilters="refreshFilters"
				@updateChangeSort="onFilters"
				:uniqId="uniqId"
				isExport
				@updateExport="onExport"
				isSettings
				@updateSettings="onSettingsOpen"
		></main-table>

		<view-selected-p-p-w-files
				v-if="isViewFilePPW"
				:items="ppwFilesList"
				@updateClose="onViewFilePPWClose"
				@updatePPWFilesClickButton="onPPWFilesClickButton"
		></view-selected-p-p-w-files>

		<preview-doc v-if="linkPreviewDoc" @clear-link="clearLinkPreviewDoc" :link-doc="linkPreviewDoc"></preview-doc>

		<v-dialog v-model="showSend" max-width="300px" class="dialog_emails">
			<v-card>
				<v-card-title class="headline green mb-2 ">
					<span class="headline">Send PPW to email</span>
				</v-card-title>
				<v-col class="d-flex justify-center flex-column align-center justify-center">
					<v-card-text v-for="(email, index) in forEmails" :key="index" :class="{'wrapper': index === 0}">
						<div class="d-flex flex-row align-center justify-center">
							<v-text-field placeholder="Enter email" label="E-mail" v-model="email.mail"
							              :rules="mailRules"></v-text-field>
							<v-btn
									icon
									color="green lighten-1"
									class="ml-4 mt-4"
									small
									type="button"
									@click="forEmails.unshift({mail:''})"
							>
								<v-icon>mdi-plus</v-icon>
							</v-btn>
							<v-btn
									icon
									color="green lighten-1"
									class="ml-4 mt-4"
									x-small
									type="button"
									@click="deleteEmails(email)"
							>
								<v-icon color="grey" dense>mdi-delete</v-icon>
							</v-btn>
						</div>
					</v-card-text>
				</v-col>
				<v-col class="d-flex justify-center">
					<v-card-actions class="card-actions">
						<v-btn text color="primary" @click="cencelSendForm">Cancel</v-btn>
						<v-btn text color="primary" @click="sendEmails">Send</v-btn>
					</v-card-actions>
				</v-col>
			</v-card>
		</v-dialog>
		
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>
		<dialog-trip
				v-if="isDialogTrip"
				:flag="flagDialogTrip"
				@updateClosePopup="onClosePopup"
				@updateRemoveTrip="onRemoveTrip"
		></dialog-trip>
	</div>
</template>
<script>

import Vuex, { mapActions, mapGetters } from "vuex";
// components
import BillingModule from "@/store/modules/accounting/billing/billing.module";
import ViewSelectedPPWFiles from "@/components/Dispatch/Trips/DialogTrip/Load/PaperWork/ViewSelectedPPWFiles.vue";

import PreviewDoc from "@/modules/invoices/preview.vue";
import DialogTrip from "@/components/Dispatch/Trips/DialogTrip/DialogTrip.vue";
const TableSettings = () => import("@/shared/TableSettings/TableSettings");
// constants
import getUniqId from "@/helper/getUniqId";
import { getAppUrl } from "@/services";

const store = new Vuex.Store();
store.registerModule('BillingModule', BillingModule);

export default {
	name: "Billing",
	components: {
		PreviewDoc,
		ViewSelectedPPWFiles,
		DialogTrip,
		TableSettings,
	},
	computed: {
		...mapGetters([
			'updateBillingData',
			'updateBillingFilters',
			'permissions',
			'billingSettingsDefault',
			'billingSettings',
			'billingHeaders',
			'ppwFilesList',
		]),
		settings() {
			return this.billingSettings;
		},
		headers() {
			return this.billingHeaders;
		}
	},
	data: () => {
		return {
			linkPreviewDoc: null,
			isViewFilePPW: false,
			isDialogTrip: false,
			flagDialogTrip: null,
			saveFilterModList: [],
			refreshFilters: false,
			title: "Billing",
			flag: "billingPage",
			showSend: false,
			loadIdToSend: null,
			forEmails: [ { mail: '' } ],
			mailRules: [ (v) => /^$|.+@.+\..+/.test(v) || "E-mail must be valid" ],

			isTableSettingsDrawer: false,
			uniqId: null,
		};
	},
	methods: {
		...mapActions([
			'getListOfBillings',
			'updateFilters',
			'sendPpwFileBiling',
			'onExportLink',
			'onBillingSettingsReset',
			'onBillingSettingsSave',
			'onBillingSettingsAll',
			"getTripDelete",
			"getListOfPpwFiles",
		]),
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},
		onPPWFilesClickButton({ item }) {
			const { url } = item;
			this.linkPreviewDoc = getAppUrl + url;
		},
		onViewFilePPWClose() {
			this.isViewFilePPW = false;
		},
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onBillingSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave() {
			await this.onBillingSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onBillingSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'billings' });
		},

		async onFilters(info) {
			this.saveFilterModList = info;
			await this.updateFilters(info.filterModList);
		},
		onEdit(onValue) {
			// this.$router.push({ path: `/trips/${ onValue.line.trip_id }` });
			this.flagDialogTrip = onValue.line.trip_id;
			this.isDialogTrip = true;
		},
		async onClosePopup(isSaveStatus) {
			this.isDialogTrip = false;
			if (isSaveStatus) {
				await this.updateFilters(this.saveFilterModList.filterModList);
			}
		},
		async onRemoveTrip(trip_id) {
			this.isDialogTrip = false;
			if (trip_id !== 'new') {
				await this.getTripDelete(trip_id);
				await this.updateFilters(this.saveFilterModList.filterModList);
			}
		},
		onClickButton({ key, item }) {
			if (key === "send") {
				this.sendPpwShow(item.load_id);
			}
			if (key === "watchFiles") {
				this.showPpwFiles(item);
			}
		},

		async sendEmails() {
			const dataToSend = this.forEmails.filter(e => e.mail !== '');
			const payLoad = { value: { data: dataToSend }, id: this.loadIdToSend };

			this.showSend = false;
			this.forEmails = [ { mail: '' } ];
			await this.sendPpwFileBiling(payLoad);
		},
		cencelSendForm() {
			this.showSend = false;
			this.forEmails = [ { mail: '' } ];
		},
		sendPpwShow(id) {
			this.loadIdToSend = id;
			this.showSend = true;
		},
		deleteEmails(mail) {
			const index = this.forEmails.findIndex(e => e.mail === mail.mail);

			this.forEmails.splice(index, 1);
		},
		async showPpwFiles(item) {
			await this.getListOfPpwFiles(item.load_id);
			this.isViewFilePPW = true;
		},
	},
	async mounted() {
		await this.getListOfBillings();
	},
};
</script>
<style lang="scss">
.billing_table {
	margin: 0;
	width: calc(100% - 80px);
	@media (max-width: 1800px) {
		width: calc(100% - 20px);
	}
}

.billing {
	margin-top: 70px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

</style>
